import { BottomSheet } from '@betty/navigation';
import { LimitReachedSocketData } from '../navigation/LimitReachedBottomSheet/LimitReachedBottomSheet.types';
import { socketConnected, startListening } from '@betty/toolkit/state';

startListening({
  actionCreator: socketConnected,
  effect: (action) => {
    const socketConnection = action.payload;

    socketConnection.on('LimitReached', (data: LimitReachedSocketData) => {
      if (!data) {
        return;
      }

      BottomSheet.open({
        namespace: 'responsibleGaming',
        type: 'LimitReached',
        data,
      });
    });
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action) => {
    const socketConnection = action.payload;

    socketConnection.on('ContactSupport', () => {
      BottomSheet.open({
        namespace: 'responsibleGaming',
        type: 'ContactSupport',
      });
    })
  },
})
